import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ElMessageBox } from 'element-plus';
import { ref, onMounted, onUnmounted } from 'vue';
import screenfull from 'screenfull';
export default /*@__PURE__*/_defineComponent({
  __name: 'ScreenFull',
  emits: ["change"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const screenRef = ref();
    const isFullscreen = ref(false);
    function toggleFullScreen() {
      if (screenfull.isEnabled) {
        screenfull.toggle(screenRef.value);
      } else {
        ElMessageBox.alert('您的浏览器不支持全屏功能', '提示', {
          confirmButtonText: '确定',
          callback: () => {}
        });
      }
    }
    const handleChange = () => {
      isFullscreen.value = screenfull.isFullscreen;
      emits('change', isFullscreen.value);
    };
    onMounted(() => {
      if (screenfull.isEnabled) {
        screenfull.on('change', handleChange);
      }
    });
    onUnmounted(() => {
      if (screenfull.isEnabled) {
        screenfull.off('change', handleChange);
      }
    });
    __expose({
      toggleFullScreen
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "screenRef",
        ref: screenRef,
        class: _normalizeClass(["screen-full", {
          'is-full': isFullscreen.value
        }])
      }, [_renderSlot(_ctx.$slots, "default"), !isFullscreen.value ? _renderSlot(_ctx.$slots, "btn", {
        key: 0,
        toggleFull: toggleFullScreen
      }) : _createCommentVNode("", true)], 2);
    };
  }
});